// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

// LIBRERIE ESTERNE
import Slider from "react-slick";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

// STILI X SLINK
import heroCarouselSyle from "../../../assets/jsStyle/heroCarouselStyle";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false /* Default a true se non specificato*/ }) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    const carouselImages = [
        {src: "/assets/images/inHome/heroCarousel/salone.webp", alt: t('homePage.carouselImage1Alt')},
        {src: "/assets/images/inHome/heroCarousel/terrazza.webp", alt: t('homePage.carouselImage2Alt')},
        {src: "/assets/images/inHome/heroCarousel/camera.webp", alt: t('homePage.carouselImage3Alt')},
    ]

    // Transizione per rendere visibile il text wrapper
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
            setBoxVisible(true)
        };

        const timer = setTimeout(handleVisible, 2000);
        return () => clearTimeout(timer);
    }, [])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner">

            <Slider {...heroCarouselSyle}>
                {carouselImages.map((image, index) => (
                    <div key={index}>
                        <img src={image.src} alt={image.alt} className="carousel-image" />
                    </div>
                ))}
            </Slider>

            { /* Attiva box a comparsa + form ricerca */}
            {false && (
                <div className="container-fluid">
                    <div className={`text-wrapper ${boxVisible ? 'visible' : ''}`}>
                        <div className="row justify-content-center">
                            <div className="col-11">
                                {showSearchForm && <PropertySearchField searchData={{}} />}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Attiva l'indicatore di scroll */}
            {false && (
                <div className="scroll-indicator">
                    <span>scroll</span>
                    <div className="scroll-bar"></div>
                </div>
            )}
        </section>
    );
};

export default SubHeaderHome;